export default "__VITE_ASSET__DfaUok5K__"